<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-list
      v-model="loading"
      class="listBody"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="item in list" :key="item.orderId" class="orderRect" @click="selectOrder(item.orderId)">
        <van-row class="titleLine">
          <van-col span="12" class="aboutStr">{{ formatDate(item.createTime, "yyyy-MM-dd hh:mm",true) }}</van-col>
          <van-col span="12" class="mainColor textRight state">{{ GetEnumText("Em_OrderState",item.state) }}</van-col>
        </van-row>
        <van-row>
          <van-col span="4"><img class="icon" :src="item.commodityIcon"></van-col>
          <van-col span="1" />
          <van-col span="19">
            <van-row>
              <van-col span="16">
                <div class="title">{{ item.commodityTitle }}</div>
                <div class="specificaion aboutStr"><span v-for="name in item.specificaionNames" :key="name">{{ name }} </span></div>
              </van-col>
              <van-col span="8" class="textRight">
                <span class="price">￥{{ item.price.toFixed(2) }}</span><br>
                <span class="num aboutStr">x{{ item.num }}</span>
              </van-col>
            </van-row>
            <div class="totalPrice textRight">合计:￥<span>{{ item.totalPrice.toFixed(2) }}</span></div>
          </van-col>
        </van-row>
      </div>
    </van-list>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, formatDate, GetEnumText } from '@/utils/base'
import { List } from 'vant'
export default {
  components: {
    [List.name]: List,
    TopBar
  },
  data() {
    return {
      title: '我的订单',
      backurl: '/users/index',
      list: [],
      loading: false,
      finished: false,
      offsetTop: 0,
      search: {
        limit: 30,
        page: 1
      }
    }
  },
  activated() {
    initPage()
    // keep-alive组件 页面进入的时候设置滚动高度
    document.documentElement.scrollTop = this.offsetTop
    console.log('activated', this.offsetTop)
  },
  beforeRouteLeave(to, from, next) {
    // keep-alive 组件停用时调用（简单理解为组件离开的时候）。
    // 获取页面滚动高度，这个钩子有可能会拿不到数据，因为这个钩子执行的慢，可以用beforeRouteLeave代替
    console.log('beforeRouteLeave', this.offsetTop)
    this.offsetTop = document.documentElement.scrollTop
    next()
  },
  created() {
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.onLoad()
  },
  methods: {
    formatDate,
    GetEnumText,
    onLoad() {
      this.loading = true
      request({
        url: '/Store/getOrderList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    selectOrder(orderId) {
      this.$router.replace('/store/orderInfo/' + orderId)
    }
  }
}
</script>
<style scoped>
.orderRect{
    background-color: #fff;
    border-top: 1px solid #dadada;
    border-bottom: 1px solid #dadada;
    margin-top: 0.8em;
    padding: 0.5em 1em;
}
.orderRect .icon{
    width: 100%;
}
.orderRect .titleLine{
    font-size: 0.8em;
    margin-bottom: 0.8em;
}
.orderRect .title{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
     font-size: 0.9em;
}
.orderRect .price{
font-size: 0.9em;
}
.orderRect .num{
font-size: 0.8em;
}
.orderRect .specificaion{
    font-size: 0.7em;
}
.orderRect .totalPrice{
font-size: 0.8em;
}
.orderRect .totalPrice span{
font-size: 1.2em;
font-weight: 700;
}
.orderRect .state{
  font-weight: 700;
}
</style>
